<template>
  <vacuum-valve :form="form" @goPageHome="goPageHome" @goPageNext="goPageNext"></vacuum-valve>
</template>

<script>
import VacuumValve from "./VacuumValve";
import { getValveDetail } from "../api/api";

export default {
  name: "VacuumValve-1",
  components: {VacuumValve},
  data() {
    return {
      form: {
        pathName: this.$t('i18n.headerMain.vacuumValve'),
        lastPathName: this.$t('i18n.headerMainChildren.MGVAGV'),
        name: "MGVAGV",
        path: "VacuumValve1",
        isLast: true,
        showChild: false,
        pathImg: require('../assets/imgs/MGVAGV.png'),
        img: require('../assets/imgs/MGAVGimg.png'),
        technicalImg: require('../assets/imgs/MGVAGVTechnical.png'),
        downloadImg: require('../assets/imgs/MGVAGVDownloadImg.png'),
        propertiesName: "MGVAGVpro",
        showFlg: true,
        type: "PDF",
        size: "4 MB"
      },
      list: [],
    }
  },

  created() {
    this.form.pathImg = this.isMobile() ? require('../assets/imgs/mgv.png') : require('../assets/imgs/mgv.png');
    this.search();
  },

  methods: {
    search() {
      getValveDetail({ id: "1" }).then(res => {
        if(res.data.code == 1){
          this.form.id = res.data.data.id;
          if (this.$store.state.language === '中文') {
            this.form.technicalImg = res.data.data.image;
          } else if (this.$store.state.language === 'English') {
            this.form.technicalImg = res.data.data.image2;
          }
        }
      });
    },
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    goPageHome() {
      this.$router.push("VacuumValveMain");
    },

    goPageNext() {
      this.$router.push("VacuumValve2")
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/VacuumValve-1.vue